import { FormControl as ChakraFormControl } from "@chakra-ui/react";

export const FormControl = ChakraFormControl;
